export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";